"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var React = require('react');

var withSideEffect = require('react-side-effect');

var PropTypes = require('prop-types');

var Component = React.Component;

var MelidataTrack = /*#__PURE__*/function (_Component) {
  _inherits(MelidataTrack, _Component);

  var _super = _createSuper(MelidataTrack);

  function MelidataTrack() {
    _classCallCheck(this, MelidataTrack);

    return _super.apply(this, arguments);
  }

  _createClass(MelidataTrack, [{
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return MelidataTrack;
}(Component);

MelidataTrack.propTypes = {
  id: PropTypes.string,
  path: PropTypes.string,
  event_data: PropTypes.object,
  application: PropTypes.object,
  device: PropTypes.object,
  user: PropTypes.object,
  platform: PropTypes.object,
  type: PropTypes.string,
  isDeferred: PropTypes.bool,
  experiments: PropTypes.object,
  userTime: PropTypes.any,
  userLocalTimeStamp: PropTypes.any,
  lastExperimentsTimeStamp: PropTypes.any
};

function reducePropsToState(propsList) {
  var props = {};
  propsList.forEach(function (currentProps) {
    Object.keys(currentProps).forEach(function (p) {
      if (_typeof(currentProps[p]) === 'object' && !Array.isArray(currentProps[p])) {
        props[p] = Object.assign({}, props[p], currentProps[p]);
      } else {
        props[p] = currentProps[p];
      }
    });
  });
  return props;
}

function handleStateChangeOnClient() {
  // Do nothing for now
  return null;
}

function mapStateOnServer(props) {
  return props;
}

module.exports = withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer)(MelidataTrack);